import { render, staticRenderFns } from "./addProxyFee.vue?vue&type=template&id=02dd9b0b&scoped=true"
import script from "./addProxyFee.vue?vue&type=script&lang=js"
export * from "./addProxyFee.vue?vue&type=script&lang=js"
import style0 from "./addProxyFee.vue?vue&type=style&index=0&id=02dd9b0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd9b0b",
  null
  
)

export default component.exports